import script from "./performers.vue?vue&type=script&setup=true&lang=js"
export * from "./performers.vue?vue&type=script&setup=true&lang=js"

import "./performers.vue?vue&type=style&index=0&id=dc2f6cb2&lang=css"

const __exports__ = script;

export default __exports__